<script setup>
	import AppMain from './components/app-main.vue'
	import AppHeader from '../layout/components/app-header.vue'
	import { ref } from 'vue'
	const clickingFlag = ref(false)
</script>
<template>
	<section id="common-layout" >
		<app-header v-model="clickingFlag"></app-header>
		<app-main v-loading="clickingFlag" />
		
	</section>
</template>

